export default __webpack_public_path__ + "static/ai-solutions-with-roadmap3--mobile-7d2cd0b1ef05408aa85a9f7cd6a3eb26.webp";